function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { PurchaseLimitType, TYPE_MAP_KEY_BY_PURCHASE_LIMIT_TYPE } from 'shared/core/constants/compliance';
import { CANNABIS_TYPES } from 'shared/core/constants/product';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { MG_TO_G, POTENCY_TYPES } from 'shared/constants';
import { safeToBig } from 'shared/helpers/utils_math';
import { getKeyFromTAC, getProductWeight, getEquivalent, getProductNetWeightInGrams, getProductVolumeInGrams } from 'shared/helpers/products';
import { COMBINED_INHALABLE_TYPES, CONCENTRATE_TYPES, EDIBLE_TYPES, TINCTURE_TYPES, TOPICAL_TYPES, GRAMS_PER_OUNCE } from './constants';
import { getStateLimits, getTypeLimits, getLimitMessage, getLimitForType, getEffectiveSubcategories, isFlower, isConcentrate, isEdible, isTincture, isTopical, isWeightedProduct, isLiquidTypeProduct, isSolidEdibleTypeProduct, formatDisplayedType, hasCategoryMappingExclusion, isCategoryMappingExclusionEnforced, getMappedPurchaseLimitType, sanitizeCategoryMappings, sanitizeCategoryMappingExclusions, applyCategoryMappingExclusions, getResolvedPurchaseLimitTypesByProductKey, getPurchaseLimitTypeOverrideMultiplier, getPhysicalFormMultiplier, isPurchaseLimitTypeOverrideEnforced } from './utils';
import { checkSolidEdibleNetWeight } from './check-solid-edible-net-weight';
import { checkLiquidEdibleVolume } from './check-liquid-edible-volume';
export var shouldCombine = function(limits, medical) {
    if (medical) {
        return limits.medUsesEquivalencyCalculator;
    }
    return limits.usesEquivalencyCalculator;
};
var PURCHASE_LIMIT_TYPE_BY_TYPE_MAP_KEY = _.invert(TYPE_MAP_KEY_BY_PURCHASE_LIMIT_TYPE);
var isTypeMapType = function() {
    var typeFromCartProduct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', subcategoriesFromCartProduct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], limits = arguments.length > 2 ? arguments[2] : void 0, typeMapKey = arguments.length > 3 ? arguments[3] : void 0, medical = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, requireEnforcedExclusion = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var purchaseLimitType = PURCHASE_LIMIT_TYPE_BY_TYPE_MAP_KEY[typeMapKey];
    var assignmentIsExcluded = requireEnforcedExclusion ? isCategoryMappingExclusionEnforced({
        type: typeFromCartProduct,
        subcategories: subcategoriesFromCartProduct
    }, {
        limits: limits,
        medical: medical,
        useMultiSubcategories: true
    }, purchaseLimitType) : hasCategoryMappingExclusion(typeFromCartProduct, subcategoriesFromCartProduct, limits, purchaseLimitType);
    if (assignmentIsExcluded) return false;
    var categories = _.get(limits, "typeMap.".concat(typeMapKey, ".categories"), []);
    var subcategories = _.get(limits, "typeMap.".concat(typeMapKey, ".subcategories"), []);
    var allCategoriesForType = _to_consumable_array(categories).concat(_to_consumable_array(subcategories));
    return _.includes(allCategoriesForType, typeFromCartProduct) || _.intersection(allCategoriesForType, subcategoriesFromCartProduct).length > 0;
};
var isIgnoreTypeMapType = function(typeFromCartProduct, subcategoriesFromCartProduct, limits, typeMapKey) {
    var medical = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    // Removing an enforced Dutchie assignment restores normal source-category routing, including undoing
    // the inverse ignore map that originally kept the product out of its source bucket.
    if (isCategoryMappingExclusionEnforced({
        type: typeFromCartProduct,
        subcategories: subcategoriesFromCartProduct
    }, {
        limits: limits,
        medical: medical,
        useMultiSubcategories: true
    })) return false;
    var ignoredCategories = _.get(limits, "ignoreTypeMap.".concat(typeMapKey, ".categories"), []);
    var ignoredSubcategories = _.get(limits, "ignoreTypeMap.".concat(typeMapKey, ".subcategories"), []);
    var allIgnoredCategoriesForType = _to_consumable_array(ignoredCategories).concat(_to_consumable_array(ignoredSubcategories));
    return _.includes(allIgnoredCategoriesForType, typeFromCartProduct) || _.intersection(allIgnoredCategoriesForType, subcategoriesFromCartProduct).length > 0;
};
export var getMultiplier = function(productType, limits, medical) {
    var subcategories = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], purchaseLimitTypeOverride = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (purchaseLimitTypeOverride) {
        if (purchaseLimitTypeOverride === PurchaseLimitType.flower) return 1;
        if (!shouldCombine(limits, medical)) return 0;
        return getPurchaseLimitTypeOverrideMultiplier(purchaseLimitTypeOverride, limits, medical) || getPhysicalFormMultiplier(productType, subcategories, limits, medical);
    }
    if (shouldCombine(limits, medical)) {
        var multType = medical ? 'med' : 'rec';
        // Some states have nested multipliers specific for rec/med
        // Use the nested multiplier if it exists
        // If not, then use the non-nested multiplier
        if (isFlower(productType) && !isIgnoreTypeMapType(productType, subcategories, limits, 'Flower', medical)) {
            return 1;
        }
        if (limits.usesSolidEdibleTypes && isSolidEdibleTypeProduct(productType, subcategories)) {
            return _.get(limits.solidNetWeightMultiplier, multType, limits.solidNetWeightMultiplier) || 0;
        }
        if (limits.usesLiquidTypes && isLiquidTypeProduct(limits, productType, subcategories)) {
            return _.get(limits.liquidNetWeightMultiplier, multType, limits.liquidNetWeightMultiplier) || 0;
        }
        if (_.includes(CONCENTRATE_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Concentrate', medical, true)) {
            return _.get(limits.concentrateMultiplier, multType, limits.concentrateMultiplier) || 0;
        }
        if (_.includes(EDIBLE_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Edible', medical, true)) {
            return _.get(limits.edibleMultiplier, multType, limits.edibleMultiplier) || 0;
        }
        if (_.includes(TINCTURE_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Tincture', medical, true)) {
            return _.get(limits.tinctureMultiplier, multType, limits.tinctureMultiplier) || 0;
        }
        if (_.includes(TOPICAL_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Topicals', medical, true)) {
            return _.get(limits.topicalMultiplier, multType, limits.topicalMultiplier) || 0;
        }
    }
    if (isFlower(productType)) {
        return 1;
    }
    return 0;
};
export var cartHasMix = function(cart) {
    var limits = cart.limits, medical = cart.medical, useMultiSubcategories = cart.useMultiSubcategories;
    var products = _.map(cart.orders, 'product');
    var productTypes = _.uniq(_.map(products, 'type'));
    var productSubcategories = _.uniq(_.flatMap(products, function(product) {
        return getEffectiveSubcategories(product, useMultiSubcategories);
    }));
    var allTypes = _to_consumable_array(productTypes).concat(_to_consumable_array(productSubcategories));
    var hasMappedType = function(typeMapKey) {
        return _.some(products, function(product) {
            return isTypeMapType(product.type, getEffectiveSubcategories(product, useMultiSubcategories), limits, typeMapKey, medical, true);
        });
    };
    var hasConcentrates = !!_.find(allTypes, isConcentrate) || hasMappedType('Concentrate');
    var hasFlower = !!_.find(allTypes, isFlower) || hasMappedType('Flower');
    var hasEdibles = !!_.find(allTypes, isEdible) || hasMappedType('Edible');
    var hasTinctures = !!_.find(allTypes, isTincture) || hasMappedType('Tincture');
    var hasTopicals = !!_.find(allTypes, isTopical) || hasMappedType('Topicals');
    return _.compact([
        hasFlower,
        hasConcentrates,
        hasEdibles,
        hasTinctures,
        hasTopicals
    ]).length > 1;
};
var getPotencyRanges = function(product) {
    var _product_THCContent, _product_CBDContent;
    if (!product) {
        return {};
    }
    var cannabinoids = _.get(product, 'cannabinoidsV2', []);
    var tacPotencyValue = getKeyFromTAC(cannabinoids, "value", 0);
    var tacPotencyRangeV2 = [
        tacPotencyValue,
        tacPotencyValue
    ];
    var thcPotencyUnit = _.get(product, 'THCContent.unit');
    var thcPotencyRange;
    var netWeightInMg = _.get(product, 'measurements.netWeight.values[0]');
    if (thcPotencyUnit === 'PERCENTAGE' && _.isArray(product === null || product === void 0 ? void 0 : (_product_THCContent = product.THCContent) === null || _product_THCContent === void 0 ? void 0 : _product_THCContent.range) && netWeightInMg) {
        var range = product.THCContent.range.map(function(percentage) {
            return parseFloat(percentage) / 100 * netWeightInMg;
        });
        thcPotencyRange = range;
    } else {
        var _product_THCContent1;
        thcPotencyRange = _.isArray(product === null || product === void 0 ? void 0 : (_product_THCContent1 = product.THCContent) === null || _product_THCContent1 === void 0 ? void 0 : _product_THCContent1.range) ? product.THCContent.range : [
            0,
            0
        ];
    }
    var cbdPotencyRange;
    var cbdPotencyUnit = _.get(product, 'CBDContent.unit');
    if (cbdPotencyUnit === 'PERCENTAGE' && _.isArray(product === null || product === void 0 ? void 0 : (_product_CBDContent = product.CBDContent) === null || _product_CBDContent === void 0 ? void 0 : _product_CBDContent.range) && netWeightInMg) {
        var range1 = product.CBDContent.range.map(function(percentage) {
            return parseFloat(percentage) / 100 * netWeightInMg;
        });
        cbdPotencyRange = range1;
    } else {
        var _product_CBDContent1;
        cbdPotencyRange = _.isArray(product === null || product === void 0 ? void 0 : (_product_CBDContent1 = product.CBDContent) === null || _product_CBDContent1 === void 0 ? void 0 : _product_CBDContent1.range) ? product.CBDContent.range : [
            0,
            0
        ];
    }
    // for each cannabinoid, if range does not have two values, give it two values
    if (cbdPotencyRange.length !== 2) {
        cbdPotencyRange = [
            0
        ].concat(_to_consumable_array(cbdPotencyRange));
    }
    if (thcPotencyRange.length !== 2) {
        thcPotencyRange = [
            0
        ].concat(_to_consumable_array(thcPotencyRange));
    }
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, cbdPotencyRange), _define_property(_obj, POTENCY_TYPES.THC, thcPotencyRange), _define_property(_obj, POTENCY_TYPES.TAC, tacPotencyRangeV2), _obj;
};
var getPotencyValues = function(product) {
    if (!product) {
        return {};
    }
    var ranges = getPotencyRanges(product);
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, _.max(ranges[POTENCY_TYPES.CBD])), _define_property(_obj, POTENCY_TYPES.THC, _.max(ranges[POTENCY_TYPES.THC])), _define_property(_obj, POTENCY_TYPES.TAC, _.max(ranges[POTENCY_TYPES.TAC])), _obj;
};
export var getProductTHCInGrams = function(param) {
    var product = param.product, quantity = param.quantity;
    var defaultWeight = product.defaultWeight;
    return safeToBig(quantity).times(Number(getPotencyValues(product).THC) || defaultWeight).div(MG_TO_G);
};
export var getProductTHCBasedOnWeight = function(param) {
    var product = param.product, quantity = param.quantity;
    var defaultWeight = product.defaultWeight, Options = product.Options;
    var weight = getProductWeight(Options, defaultWeight, quantity);
    return weight;
};
var applyThcVarianceTolerance = function(thcInGrams) {
    var limits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var thcVarianceTolerance = limits.thcVarianceTolerance;
    if (thcVarianceTolerance) {
        return Number(safeToBig(thcInGrams).div(1 + thcVarianceTolerance));
    }
    return thcInGrams;
};
var getEnforcedPurchaseLimitTypeOverride = function(product, context) {
    return isPurchaseLimitTypeOverrideEnforced(product, context) ? product.purchaseLimitTypeOverride : null;
};
/**
 * Calculates Flower-equivalent grams using an explicit purchase-limit type override.
 * Returns null when no override applies so a calculated zero remains distinguishable.
 */ var getPurchaseLimitTypeOverrideFlowerEquivalent = function(order, medical, limits, subcategories) {
    var product = order.product, option = order.option, quantity = order.quantity;
    var defaultWeight = product.defaultWeight, type = product.type;
    var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(_object_spread_props(_object_spread({}, product), {
        subcategories: subcategories
    }), {
        limits: limits,
        medical: medical,
        useMultiSubcategories: true
    });
    if (!enforcedPurchaseLimitTypeOverride) return null;
    var _limits_baseConcentrateOffWeight = limits.baseConcentrateOffWeight, baseConcentrateOffWeight = _limits_baseConcentrateOffWeight === void 0 ? true : _limits_baseConcentrateOffWeight, _limits_baseTincturesOffWeight = limits.baseTincturesOffWeight, baseTincturesOffWeight = _limits_baseTincturesOffWeight === void 0 ? false : _limits_baseTincturesOffWeight;
    var _product_multiplier;
    var multiplier = (_product_multiplier = product.multiplier) !== null && _product_multiplier !== void 0 ? _product_multiplier : 1;
    var hasPurchaseLimitTypeMultiplier = getPurchaseLimitTypeOverrideMultiplier(enforcedPurchaseLimitTypeOverride, limits, medical) > 0;
    if (enforcedPurchaseLimitTypeOverride !== PurchaseLimitType.flower && shouldCombine(limits, medical) && !hasPurchaseLimitTypeMultiplier) {
        if (limits.usesSolidEdibleTypes && isSolidEdibleTypeProduct(type, subcategories)) {
            return parseFloat(safeToBig(getProductNetWeightInGrams(product) * quantity).times(multiplier));
        }
        if (limits.usesLiquidTypes && isLiquidTypeProduct(limits, type, subcategories)) {
            return parseFloat(safeToBig(getProductVolumeInGrams(product) * quantity).times(multiplier));
        }
    }
    var equivalent;
    switch(enforcedPurchaseLimitTypeOverride){
        case PurchaseLimitType.flower:
            equivalent = getProductWeight(option, defaultWeight, quantity);
            break;
        case PurchaseLimitType.concentrate:
            equivalent = baseConcentrateOffWeight ? getProductWeight(option, defaultWeight, quantity) : getProductTHCInGrams(order);
            break;
        case PurchaseLimitType.edibleTHC:
            equivalent = limits.baseEdiblesOffWeight ? getProductTHCBasedOnWeight(order) : getProductTHCInGrams(order);
            break;
        case PurchaseLimitType.tinctureTHC:
            equivalent = baseTincturesOffWeight ? getProductTHCBasedOnWeight(order) : getProductTHCInGrams(order);
            break;
        case PurchaseLimitType.topicalTHC:
            equivalent = getProductTHCInGrams(order);
            break;
        default:
            equivalent = 0;
    }
    return parseFloat(safeToBig(equivalent).times(multiplier));
};
export var getFlowerEquivalent = function(order, medical) {
    var limits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, useMultiSubcategories = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var product = order.product, option = order.option, quantity = order.quantity;
    var defaultWeight = product.defaultWeight, type = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var _limits_baseConcentrateOffWeight = limits.baseConcentrateOffWeight, baseConcentrateOffWeight = _limits_baseConcentrateOffWeight === void 0 ? true : _limits_baseConcentrateOffWeight, _limits_baseTincturesOffWeight = limits.baseTincturesOffWeight, baseTincturesOffWeight = _limits_baseTincturesOffWeight === void 0 ? false : _limits_baseTincturesOffWeight;
    var overrideFlowerEquivalent = getPurchaseLimitTypeOverrideFlowerEquivalent(order, medical, limits, subcategories);
    if (overrideFlowerEquivalent !== null) return overrideFlowerEquivalent;
    var standardEquivalent = getEquivalent(product, option, quantity);
    var recEquivalent = getEquivalent(product, option, quantity, 'recEquivalent');
    /*
   * This logic is just to allow IL dispensaries to pass the standardEquivalent field on products
   * even though it shouldn't be used due to their config using equivalency for medical but not recreational
   * orders. IL is the only state config that includes the limits.ignoreStandardEquivalentField
   * - Mack H. 11/5/21
   */ var allowStandardEquivalentFieldUse = !(limits === null || limits === void 0 ? void 0 : limits.ignoreStandardEquivalentField);
    if (_.isFinite(recEquivalent) && !medical) {
        return recEquivalent;
    }
    if (_.isFinite(standardEquivalent) && allowStandardEquivalentFieldUse) {
        return standardEquivalent;
    }
    var _product_multiplier;
    var multiplier = product.purchaseLimitTypeOverride ? getMultiplier(type, limits, medical, subcategories) : (_product_multiplier = product.multiplier) !== null && _product_multiplier !== void 0 ? _product_multiplier : 1;
    var weightInGrams;
    if ((limits === null || limits === void 0 ? void 0 : limits.solidNetWeightMultiplier) && isSolidEdibleTypeProduct(type, subcategories)) {
        weightInGrams = getProductNetWeightInGrams(product) * quantity;
        return parseFloat(safeToBig(weightInGrams).times(multiplier));
    }
    if ((limits === null || limits === void 0 ? void 0 : limits.liquidNetWeightMultiplier) && isLiquidTypeProduct(limits, type, subcategories)) {
        weightInGrams = getProductVolumeInGrams(product) * quantity;
        /*
     * Sometimes users of TechPOS will still use the netWeight in measurements rather than volume as suggested
     * so this just acts as a double check for that scenario
     */ if (weightInGrams === 0) {
            weightInGrams = getProductNetWeightInGrams(product) * quantity;
        }
        return parseFloat(safeToBig(weightInGrams).times(multiplier));
    }
    weightInGrams = isEdible(type) || isTincture(type) && !baseTincturesOffWeight || isTopical(type) || isConcentrate(type) && !baseConcentrateOffWeight ? getProductTHCInGrams(order) : getProductWeight(option, defaultWeight, quantity);
    return parseFloat(safeToBig(weightInGrams).times(multiplier));
};
export var getEdibleTHCInGrams = function(order) {
    var type = order.product.type;
    return isEdible(type) ? getProductTHCInGrams(order) : 0;
};
export var getTinctureTHCInGrams = function(order) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_baseTincturesOffWeight = _ref.baseTincturesOffWeight, baseTincturesOffWeight = _ref_baseTincturesOffWeight === void 0 ? false : _ref_baseTincturesOffWeight;
    var type = order.product.type;
    if (baseTincturesOffWeight) {
        return isTincture(type) ? getProductTHCBasedOnWeight(order) : 0;
    }
    return isTincture(type) ? getProductTHCInGrams(order) : 0;
};
export var getTopicalTHCInGrams = function(order) {
    var type = order.product.type;
    return isTopical(type) ? getProductTHCInGrams(order) : 0;
};
export var getTotalFlowerInGrams = function(param) {
    var limits = param.limits, orders = param.orders, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_Flower, _limits_ignoreTypeMap;
        /**
         * Prevent any excluded subcategories from triggering state flower limits unless
         * we still need to check equivalency. For example in NV infused pre-rolls are counted as
         * concentrates but need to still count to the overall flower limit
         */ var subcategories = getEffectiveSubcategories(order.product, useMultiSubcategories);
        var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(order.product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var staticAssignmentRemoved = isCategoryMappingExclusionEnforced(order.product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        if (enforcedPurchaseLimitTypeOverride && enforcedPurchaseLimitTypeOverride !== PurchaseLimitType.flower && !shouldCombine(limits, medical)) {
            return safeToBig(previous);
        }
        if (!enforcedPurchaseLimitTypeOverride && !staticAssignmentRemoved && _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Flower = _limits_ignoreTypeMap.Flower) === null || _limits_ignoreTypeMap_Flower === void 0 ? void 0 : _limits_ignoreTypeMap_Flower.subcategories, subcategories).length > 0 && !shouldCombine(limits, medical)) {
            return safeToBig(previous);
        }
        return safeToBig(previous).plus(safeToBig(getFlowerEquivalent(order, medical, limits, useMultiSubcategories)));
    }, 0));
};
export var getTotalTinctureTHCInGrams = function(param) {
    var orders = param.orders, limits = param.limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(order.product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        if (enforcedPurchaseLimitTypeOverride && enforcedPurchaseLimitTypeOverride !== PurchaseLimitType.tinctureTHC) return safeToBig(previous);
        if (enforcedPurchaseLimitTypeOverride === PurchaseLimitType.tinctureTHC) {
            var amount = limits.baseTincturesOffWeight ? getProductTHCBasedOnWeight(order) : getProductTHCInGrams(order);
            return safeToBig(previous).plus(safeToBig(amount));
        }
        return safeToBig(previous).plus(safeToBig(getTinctureTHCInGrams(order, limits)));
    }, 0.0));
};
export var getTotalTopicalTHCInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_Topicals, _limits_ignoreTypeMap, _limits_ignoreTypeMap_Topicals1, _limits_ignoreTypeMap1;
        var product = order.product;
        var type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var staticAssignmentRemoved = isCategoryMappingExclusionEnforced(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var categoryIgnored = !staticAssignmentRemoved && _.includes(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Topicals = _limits_ignoreTypeMap.Topicals) === null || _limits_ignoreTypeMap_Topicals === void 0 ? void 0 : _limits_ignoreTypeMap_Topicals.categories, type);
        var subcategoryIgnored = !staticAssignmentRemoved && _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap1 = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap1 === void 0 ? void 0 : (_limits_ignoreTypeMap_Topicals1 = _limits_ignoreTypeMap1.Topicals) === null || _limits_ignoreTypeMap_Topicals1 === void 0 ? void 0 : _limits_ignoreTypeMap_Topicals1.subcategories, subcategories).length > 0;
        var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var shouldCheckWeightForType = enforcedPurchaseLimitTypeOverride ? enforcedPurchaseLimitTypeOverride === PurchaseLimitType.topicalTHC : !categoryIgnored && !subcategoryIgnored;
        var amount = enforcedPurchaseLimitTypeOverride === PurchaseLimitType.topicalTHC ? getProductTHCInGrams(order) : getTopicalTHCInGrams(order);
        return shouldCheckWeightForType ? safeToBig(previous).plus(safeToBig(amount)) : safeToBig(previous);
    }, 0.0));
};
export var getTotalEdibleTHCInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var product = order.product;
        var type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var _limits_baseEdiblesOffWeight = limits.baseEdiblesOffWeight, baseEdiblesOffWeight = _limits_baseEdiblesOffWeight === void 0 ? false : _limits_baseEdiblesOffWeight;
        var edibleCategories = _.get(limits, 'typeMap.Edible.categories', EDIBLE_TYPES);
        var edibleSubcategories = _.get(limits, 'typeMap.Edible.subcategories', []);
        var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var hasMatchingAssignmentExclusion = isCategoryMappingExclusionEnforced(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        }, PurchaseLimitType.edibleTHC);
        var isEdibleType;
        if (enforcedPurchaseLimitTypeOverride) {
            isEdibleType = enforcedPurchaseLimitTypeOverride === PurchaseLimitType.edibleTHC;
        } else if (hasMatchingAssignmentExclusion) {
            isEdibleType = _.includes(EDIBLE_TYPES, type);
        } else {
            isEdibleType = _.includes(edibleCategories, type) || _.intersection(edibleSubcategories, subcategories).length > 0;
        }
        if (baseEdiblesOffWeight) {
            return isEdibleType ? safeToBig(previous).plus(safeToBig(getProductTHCBasedOnWeight(order))) : safeToBig(previous);
        }
        return isEdibleType ? safeToBig(previous).plus(safeToBig(getProductTHCInGrams(order))) : safeToBig(previous);
    }, 0.0));
};
export var getTotalConcentrateInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, medical = param.medical, state = param.state, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_Concentrate, _limits_ignoreTypeMap, _limits_ignoreTypeMap_Concentrate1, _limits_ignoreTypeMap1;
        var product = order.product, quantity = order.quantity, option = order.option;
        var defaultWeight = product.defaultWeight, type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var _limits_baseConcentrateOffWeight = limits.baseConcentrateOffWeight, baseConcentrateOffWeight = _limits_baseConcentrateOffWeight === void 0 ? true : _limits_baseConcentrateOffWeight;
        var isWeighted = isWeightedProduct(product);
        var concentrateCategories = _.get(limits, 'typeMap.Concentrate.categories', CONCENTRATE_TYPES);
        var concentrateSubcategories = _.get(limits, 'typeMap.Concentrate.subcategories', []);
        // Preserve the legacy static mapping behavior; customer mappings use purchaseLimitTypeOverride below.
        var hasMatchingAssignmentExclusion = isCategoryMappingExclusionEnforced(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        }, PurchaseLimitType.concentrate);
        var staticAssignmentRemoved = isCategoryMappingExclusionEnforced(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var categoryIgnored = !staticAssignmentRemoved && _.includes(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Concentrate = _limits_ignoreTypeMap.Concentrate) === null || _limits_ignoreTypeMap_Concentrate === void 0 ? void 0 : _limits_ignoreTypeMap_Concentrate.categories, type);
        var subcategoryIgnored = !staticAssignmentRemoved && _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap1 = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap1 === void 0 ? void 0 : (_limits_ignoreTypeMap_Concentrate1 = _limits_ignoreTypeMap1.Concentrate) === null || _limits_ignoreTypeMap_Concentrate1 === void 0 ? void 0 : _limits_ignoreTypeMap_Concentrate1.subcategories, subcategories).length > 0;
        var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var shouldCheckWeightForType = enforcedPurchaseLimitTypeOverride ? enforcedPurchaseLimitTypeOverride === PurchaseLimitType.concentrate : !categoryIgnored && !subcategoryIgnored;
        var isBritishColumbiaDispensary = state === 'BC';
        var flowerEquivalent = getFlowerEquivalent(order, medical, limits, useMultiSubcategories);
        var useEquivalent = isBritishColumbiaDispensary && !!flowerEquivalent;
        var productWeight = baseConcentrateOffWeight && isWeighted ? getProductWeight(option, defaultWeight, quantity) : getProductTHCInGrams(order);
        var includedByStaticMapping = hasMatchingAssignmentExclusion ? _.includes(CONCENTRATE_TYPES, type) : _.includes(concentrateCategories, type) || _.intersection(concentrateSubcategories, subcategories).length > 0;
        return shouldCheckWeightForType && (enforcedPurchaseLimitTypeOverride === PurchaseLimitType.concentrate || includedByStaticMapping) ? safeToBig(previous).plus(safeToBig(useEquivalent ? flowerEquivalent : productWeight)) : safeToBig(previous);
    }, 0.0));
};
/**
 * Sums the gram weight of products assigned to a jurisdiction's independent inhalable-products
 * bucket (Oregon's "cannabinoid products intended for inhalation"). Mirrors the concentrate
 * total but is driven purely by the static CombinedInhalable typeMap and is restricted to
 * inhalable storefront categories, so a product from a non-inhalable category that merely
 * shares a subcategory tag cannot consume the inhalation allowance. Products carrying an
 * enforced merchant purchase-limit-type override follow their override bucket instead.
 */ export var getTotalCombinedInhalableInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_CombinedInhalable, _limits_ignoreTypeMap, _limits_ignoreTypeMap_CombinedInhalable1, _limits_ignoreTypeMap1;
        var product = order.product, quantity = order.quantity, option = order.option;
        var defaultWeight = product.defaultWeight, type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var _limits_baseConcentrateOffWeight = limits.baseConcentrateOffWeight, baseConcentrateOffWeight = _limits_baseConcentrateOffWeight === void 0 ? true : _limits_baseConcentrateOffWeight;
        var isWeighted = isWeightedProduct(product);
        var combinedInhalableCategories = _.get(limits, 'typeMap.CombinedInhalable.categories', []);
        var combinedInhalableSubcategories = _.get(limits, 'typeMap.CombinedInhalable.subcategories', []);
        var categoryIgnored = _.includes(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_CombinedInhalable = _limits_ignoreTypeMap.CombinedInhalable) === null || _limits_ignoreTypeMap_CombinedInhalable === void 0 ? void 0 : _limits_ignoreTypeMap_CombinedInhalable.categories, type);
        var subcategoryIgnored = _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap1 = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap1 === void 0 ? void 0 : (_limits_ignoreTypeMap_CombinedInhalable1 = _limits_ignoreTypeMap1.CombinedInhalable) === null || _limits_ignoreTypeMap_CombinedInhalable1 === void 0 ? void 0 : _limits_ignoreTypeMap_CombinedInhalable1.subcategories, subcategories).length > 0;
        var enforcedPurchaseLimitTypeOverride = getEnforcedPurchaseLimitTypeOverride(product, {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        });
        var includedByStaticMapping = _.includes(COMBINED_INHALABLE_TYPES, type) && (_.includes(combinedInhalableCategories, type) || _.intersection(combinedInhalableSubcategories, subcategories).length > 0);
        if (enforcedPurchaseLimitTypeOverride || categoryIgnored || subcategoryIgnored || !includedByStaticMapping) {
            return safeToBig(previous);
        }
        // The weight is only resolved for included products: excluded ones may be non-weighted
        // products without potency data, and their weight is never needed.
        var productWeight = baseConcentrateOffWeight && isWeighted ? getProductWeight(option, defaultWeight, quantity) : getProductTHCInGrams(order);
        return safeToBig(previous).plus(safeToBig(productWeight));
    }, 0.0));
};
export var getSerializedOrders = function(param) {
    var cart = param.cart, limits = param.limits, medical = param.medical, state = param.state, useMultiSubcategories = param.useMultiSubcategories, _param_categoryMappings = param.categoryMappings, categoryMappings = _param_categoryMappings === void 0 ? [] : _param_categoryMappings;
    var defaultOptionWeights = getComplianceConfig(state, 'defaults');
    var applicableOrders = _.filter(cart, function(param) {
        var product = param.product;
        return _.includes(CANNABIS_TYPES, product.type);
    });
    return _.map(applicableOrders, function(order) {
        var product = order.product, quantity = order.quantity, option = order.option;
        var type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var purchaseLimitTypeOverride = getMappedPurchaseLimitType(product, categoryMappings, useMultiSubcategories);
        var serializedProduct = _object_spread_props(_object_spread({}, product, purchaseLimitTypeOverride ? {
            purchaseLimitTypeOverride: purchaseLimitTypeOverride
        } : {}), {
            multiplier: getMultiplier(type, limits, medical, subcategories, purchaseLimitTypeOverride),
            defaultWeight: defaultOptionWeights[type]
        });
        return {
            product: serializedProduct,
            quantity: quantity,
            option: option
        };
    });
};
export var getSerializedCart = function(param) {
    var state = param.state, cart = param.cart, purchaseState = param.purchaseState, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories, dispensary = param.dispensary, _param_configurablePurchaseLimitsFeatureEnabled = param.configurablePurchaseLimitsFeatureEnabled, configurablePurchaseLimitsFeatureEnabled = _param_configurablePurchaseLimitsFeatureEnabled === void 0 ? false : _param_configurablePurchaseLimitsFeatureEnabled;
    // Merge overrides before serialization and never apply them to out-of-state customers.
    var isOutOfStateCustomer = Boolean(state && purchaseState && state !== purchaseState);
    var _mergeCustomPurchaseLimits = mergeCustomPurchaseLimits(getStateLimits(state, purchaseState), dispensary, isOutOfStateCustomer, configurablePurchaseLimitsFeatureEnabled), limits = _mergeCustomPurchaseLimits.limits, categoryMappings = _mergeCustomPurchaseLimits.categoryMappings;
    var orders = getSerializedOrders({
        cart: cart,
        limits: limits,
        medical: medical,
        state: state,
        useMultiSubcategories: useMultiSubcategories,
        categoryMappings: categoryMappings
    });
    return {
        orders: orders,
        state: state,
        limits: limits,
        medical: medical,
        useMultiSubcategories: useMultiSubcategories,
        categoryMappings: categoryMappings
    };
};
export var checkFlowerLimit = function(cart) {
    var limits = cart.limits, medical = cart.medical, state = cart.state, useMultiSubcategories = cart.useMultiSubcategories;
    var flowerLimit = getTypeLimits(cart).flowerLimit;
    var mixedTypesInCart = cartHasMix(cart);
    var shouldCombineAmounts = shouldCombine(limits, medical);
    var isMixOrder = mixedTypesInCart && shouldCombineAmounts;
    // This was added to allow for product specific limit messages even when equivalency is triggered for
    // orders that are of a single product to improve compliance messaging in Canada - Mack H. 3/15/2021
    var isEquivalencyWithSingleType = !mixedTypesInCart && shouldCombineAmounts;
    var limitMessage = getLimitMessage("".concat(isMixOrder ? 'cannabis' : 'flower'), flowerLimit, state);
    if (isEquivalencyWithSingleType) {
        var productTypeAndSubcategory = _.head(_.map(cart.orders, function(param) {
            var product = param.product;
            return {
                type: product.type,
                subcategory: product.subcategory,
                subcategories: product.subcategories,
                purchaseLimitTypeOverride: product.purchaseLimitTypeOverride
            };
        }));
        var productLimit = getLimitForType(productTypeAndSubcategory, cart, useMultiSubcategories);
        var typeToDisplay = productTypeAndSubcategory.type;
        if (productTypeAndSubcategory.purchaseLimitTypeOverride === PurchaseLimitType.flower) {
            productLimit = flowerLimit;
            typeToDisplay = PurchaseLimitType.flower;
        }
        var subcategoriesForDisplay = getEffectiveSubcategories(productTypeAndSubcategory, useMultiSubcategories);
        if (limits.usesLiquidTypes && isLiquidTypeProduct(limits, typeToDisplay, subcategoriesForDisplay)) {
            typeToDisplay = 'liquids';
            productLimit *= GRAMS_PER_OUNCE;
        }
        if (productTypeAndSubcategory.type !== 'Seeds') {
            limitMessage = getLimitMessage(formatDisplayedType(typeToDisplay), productLimit, state);
        } else {
            limitMessage = getLimitMessage('cannabis', flowerLimit, state);
        }
    }
    var totalFlowerInGrams = getTotalFlowerInGrams(cart);
    return totalFlowerInGrams > flowerLimit ? {
        type: 'Flower',
        total: totalFlowerInGrams,
        message: limitMessage,
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkEdibleTHCLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var _getTypeLimits = getTypeLimits(cart), edibleTHCLimit = _getTypeLimits.edibleTHCLimit, ignoreEdibleLimit = _getTypeLimits.ignoreEdibleLimit;
    if (ignoreEdibleLimit) {
        return {
            withinLimits: true
        };
    }
    var totalEdibleTHCInGrams = applyThcVarianceTolerance(getTotalEdibleTHCInGrams(cart), limits);
    return totalEdibleTHCInGrams > edibleTHCLimit ? {
        type: 'Edible',
        total: totalEdibleTHCInGrams,
        message: getLimitMessage('edible THC', edibleTHCLimit, state, 'mg'),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkConcentrateLimit = function(cart) {
    var state = cart.state;
    var concentrateLimit = getTypeLimits(cart).concentrateLimit;
    var totalConcentrateInGrams = getTotalConcentrateInGrams(cart);
    return totalConcentrateInGrams > concentrateLimit ? {
        type: 'Concentrate',
        total: totalConcentrateInGrams,
        message: getLimitMessage('concentrates', concentrateLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkCombinedInhalableLimit = function(cart) {
    var state = cart.state;
    var combinedInhalableLimit = getTypeLimits(cart).combinedInhalableLimit;
    var totalCombinedInhalableInGrams = getTotalCombinedInhalableInGrams(cart);
    return totalCombinedInhalableInGrams > combinedInhalableLimit ? {
        type: 'CombinedInhalable',
        total: totalCombinedInhalableInGrams,
        message: getLimitMessage('combined inhalable products', combinedInhalableLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkTinctureLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var tinctureLimit = getTypeLimits(cart).tinctureLimit;
    var totalTinctureTHCInGrams = applyThcVarianceTolerance(getTotalTinctureTHCInGrams(cart), limits);
    return totalTinctureTHCInGrams > tinctureLimit ? {
        type: 'Tincture',
        total: totalTinctureTHCInGrams,
        message: getLimitMessage('tinctures', tinctureLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkTopicalLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var topicalLimit = getTypeLimits(cart).topicalLimit;
    var totalTopicalTHCInGrams = applyThcVarianceTolerance(getTotalTopicalTHCInGrams(cart), limits);
    return totalTopicalTHCInGrams > topicalLimit ? {
        type: 'Topicals',
        total: totalTopicalTHCInGrams,
        message: getLimitMessage('topicals', topicalLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkNonFlowerLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var nonFlowerLimit = getTypeLimits(cart).nonFlowerLimit;
    if (nonFlowerLimit) {
        // choose any of these non-flower limits as our baseline for comparison
        var totalTopicalTHCInGrams = getTotalTopicalTHCInGrams(cart);
        var totalTinctureTHCInGrams = getTotalTinctureTHCInGrams(cart);
        var totalConcentrateInGrams = getTotalConcentrateInGrams(cart);
        var totalEdibleTHCInGrams = getTotalEdibleTHCInGrams(cart);
        // Variance tolerance only applies to THC-based amounts, not weight-based concentrates
        var nonFlowerTHCSum = applyThcVarianceTolerance(totalTopicalTHCInGrams + totalTinctureTHCInGrams + totalEdibleTHCInGrams, limits) + totalConcentrateInGrams;
        return nonFlowerTHCSum > nonFlowerLimit ? {
            type: 'Non-Flower',
            total: nonFlowerTHCSum,
            message: getLimitMessage('non-flower items', nonFlowerLimit, state),
            withinLimits: false
        } : {
            withinLimits: true
        };
    }
    return {
        withinLimits: true
    };
};
export var CUSTOMER_LIMIT_KEYS = [
    'Flower',
    'Concentrate',
    'EdibleTHC',
    'TopicalTHC',
    'TinctureTHC',
    'SolidEdibleNetWeight',
    'LiquidEdibleVolumeInOunces',
    'nonFlower'
];
var sanitizeCustomPurchaseLimits = function(customPurchaseLimits) {
    var sanitized = {};
    CUSTOMER_LIMIT_KEYS.forEach(function(key) {
        var value = customPurchaseLimits[key];
        if (_.isPlainObject(value)) {
            var caps = _.pickBy(_.pick(value, [
                'medical',
                'rec'
            ]), function(cap) {
                return _.isFinite(cap) && cap >= 0;
            });
            if (!_.isEmpty(caps)) sanitized[key] = caps;
        }
    });
    return sanitized;
};
var getCustomPurchaseLimitsConfiguration = function(dispensary) {
    var isOutOfStateCustomer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, configurablePurchaseLimitsFeatureEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!configurablePurchaseLimitsFeatureEnabled || isOutOfStateCustomer) return null;
    var enabled = _.get(dispensary, 'storeSettings.configurablePurchaseLimitsEnabled', false);
    var configuration = _.get(dispensary, 'storeSettings.customPurchaseLimits');
    var currentState = _.get(dispensary, 'location.state');
    if (!enabled || !_.isPlainObject(configuration) || configuration.state !== currentState) return null;
    var _configuration_limits, _configuration_categoryMappings, _configuration_categoryMappingExclusions;
    return {
        limits: sanitizeCustomPurchaseLimits((_configuration_limits = configuration.limits) !== null && _configuration_limits !== void 0 ? _configuration_limits : {}),
        categoryMappings: sanitizeCategoryMappings((_configuration_categoryMappings = configuration.categoryMappings) !== null && _configuration_categoryMappings !== void 0 ? _configuration_categoryMappings : []),
        categoryMappingExclusions: sanitizeCategoryMappingExclusions((_configuration_categoryMappingExclusions = configuration.categoryMappingExclusions) !== null && _configuration_categoryMappingExclusions !== void 0 ? _configuration_categoryMappingExclusions : [])
    };
};
var mergeCustomPurchaseLimits = function(limits, dispensary) {
    var isOutOfStateCustomer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, configurablePurchaseLimitsFeatureEnabled = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var configuration = getCustomPurchaseLimitsConfiguration(dispensary, isOutOfStateCustomer, configurablePurchaseLimitsFeatureEnabled);
    var mergedLimits = configuration ? _.merge({}, limits, configuration.limits) : limits;
    var _configuration_categoryMappings;
    return {
        limits: configuration ? applyCategoryMappingExclusions(mergedLimits, configuration.categoryMappingExclusions) : mergedLimits,
        categoryMappings: (_configuration_categoryMappings = configuration === null || configuration === void 0 ? void 0 : configuration.categoryMappings) !== null && _configuration_categoryMappings !== void 0 ? _configuration_categoryMappings : []
    };
};
var updateLimits = function(cart, dispensary) {
    var usePotencyForConcentrateLimits = _.get(dispensary, 'storeSettings.usePotencyForConcentrateLimits', false);
    var useStandardEquivalentForEdiblesLimits = _.get(dispensary, 'storeSettings.useStandardEquivalentForEdiblesLimits', false);
    var state = cart.state;
    if (useStandardEquivalentForEdiblesLimits) {
        cart.limits.ignoreEdibleLimit = true;
    }
    if (state === 'MA') {
        cart.limits.baseConcentrateOffWeight = !usePotencyForConcentrateLimits;
    }
    return cart;
};
export var checkLimits = function(orderData) {
    var _orderData_dispensary = orderData.dispensary, dispensary = _orderData_dispensary === void 0 ? {} : _orderData_dispensary;
    var cart = getSerializedCart(_object_spread_props(_object_spread({}, orderData), {
        dispensary: dispensary
    }));
    cart = updateLimits(cart, dispensary);
    var messageOverride = _.get(cart, 'limits.message', null);
    if (_.isEmpty(cart.orders)) {
        return {
            withinLimits: true
        };
    }
    var resolvedPurchaseLimitTypesByProductKey = getResolvedPurchaseLimitTypesByProductKey(cart);
    return _.reduce([
        checkFlowerLimit,
        checkNonFlowerLimit,
        checkEdibleTHCLimit,
        checkConcentrateLimit,
        checkCombinedInhalableLimit,
        checkTinctureLimit,
        checkTopicalLimit,
        function(cartToCheck) {
            return checkSolidEdibleNetWeight(cartToCheck, getFlowerEquivalent);
        },
        function(cartToCheck) {
            return checkLiquidEdibleVolume(cartToCheck, getFlowerEquivalent);
        }
    ], function(previous, limitChecker) {
        var result = limitChecker(cart);
        if (messageOverride) {
            if (_.isPlainObject(messageOverride)) {
                var _result_type;
                var _messageOverride_result_type, _ref;
                var typeOverride = (_ref = (_messageOverride_result_type = messageOverride[result.type]) !== null && _messageOverride_result_type !== void 0 ? _messageOverride_result_type : messageOverride[(_result_type = result.type) === null || _result_type === void 0 ? void 0 : _result_type.toLowerCase()]) !== null && _ref !== void 0 ? _ref : messageOverride[_.camelCase(result.type)];
                if (typeOverride) {
                    result.message = typeOverride;
                }
            } else if (typeof messageOverride === 'string') {
                result.message = messageOverride;
            }
        }
        if (!result.withinLimits && result.type) {
            result.typesOverLimit = previous.typesOverLimit ? _to_consumable_array(previous.typesOverLimit).concat([
                result.type
            ]) : [
                result.type
            ];
            if (!_.isEmpty(resolvedPurchaseLimitTypesByProductKey)) {
                result.resolvedPurchaseLimitTypesByProductKey = resolvedPurchaseLimitTypesByProductKey;
            }
        }
        return !result.withinLimits ? result : previous;
    }, {
        withinLimits: true
    });
};
